import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "oxd-table-loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_loading_spinner = _resolveComponent("oxd-loading-spinner")!
  const _component_oxd_card_table_container = _resolveComponent("oxd-card-table-container")!

  return (_openBlock(), _createBlock(_component_oxd_card_table_container, null, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_oxd_loading_spinner)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tableDeco.headerDecorator))),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tableDeco.bodyDecorator)))
          ], 64))
    ]),
    _: 1
  }))
}